/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
  permissions: []
};

const getters = {
  getUserPermissions: (state) => state.permissions,
};

const actions = {
  async getUserPermissions({ commit }, data) {
    try {

      const response = await axios.get(`${url}/roles/getByRole/`);
      const permissions = response.data.role.Permissions;

      commit("SET_PERMISSIONS", permissions);
      return response;
    } catch (error) {
      commit("SET_PERMISSIONS", []);
      return error.response;
    }
  },
};

const mutations = {
  SET_PERMISSIONS(state, data) {
    state.permissions = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
